
import { FlyPointPass } from '../common/flypointpass'

import Tween from 'root/animator/tween/tween'
import Ease from 'root/animator/tween/easing'

import { layers } from '../constants'
import { screens } from 'components/sections/constants'

class Points {
    instance

    state = {
        changing: false,
        screen: screens.NONE
    }

    iAnimation = {
        o: 0,
        x: 0,
        y: 0,
        z: 10
    }

    constructor(scene) {
        this.instance = new FlyPointPass()
        this.instance.shader.uniforms[ 'iAlpha' ].value = this.iAnimation.o
        this.instance.shader.uniforms[ 'iAnimation' ].value.z = this.iAnimation.z
        this.instance.scene.position.set(0, 0, -1)
        this.instance.scene.layers.enable(layers.ENTIRE_SCENE)
        scene.add( this.instance.scene )
    }


    resize() {
        this.instance.uniforms[ 'iResolution' ].value.x = window.innerWidth * window.devicePixelRatio;
        this.instance.uniforms[ 'iResolution' ].value.y = window.innerHeight * window.devicePixelRatio;
    }

    toggle({ duration = 2000, delay = 0, opacity = 1, x = 0, y = 0, z = 0 }) {
        const from = {
            opacity: this.iAnimation.o,
            x: this.iAnimation.x,
            y: this.iAnimation.y,
            z: this.iAnimation.z
        }
        const to = { opacity, x, y, z }
        
        Tween.to(from, to, {
            duration,
            delay,
            renderDelay: 10,
            ease: Ease.InOutQuintic,
            onChange: function( context ) {
                this.instance.material.uniforms.iAlpha.value = context.value.opacity
                this.instance.material.uniforms.iAnimation.value.x = context.value.x
                this.instance.material.uniforms.iAnimation.value.y = context.value.y
                this.instance.material.uniforms.iAnimation.value.z = context.value.z
            }.bind(this),
            onComplete: function() {
                this.state.changing = false
                this.iAnimation.o = opacity
                this.iAnimation.x = x
                this.iAnimation.y = y
                this.iAnimation.z = z
            }.bind(this)
        })
    }

    render({ screen = screens.NONE, opacity = 1, x = 0, y = 0, z = 0 }) {
        if ( !this.state.changing ) {
            if (this.state.screen !== screen) {
                this.state.changing = true
                this.state.screen = screen
                this.toggle({ opacity, x, y, z })
            }
        }


        if ( opacity || this.iAnimation.o ) {
            const t = performance.now() / 1000
            this.instance.update(t)
        }
    }
}

export default Points